// Romanian CUI (cod unic de înregistrare) format check.
// Keep in sync with supabase/functions/_shared/cui.ts (Edge Functions can't import from src/).

const CONTROL_KEY = '753217532';

export function normalizeCui(raw: string): string {
  return raw.replace(/\s+/g, '').replace(/^ro/i, '');
}

/** 2–10 digits; the last digit is a control digit computed with the 753217532 key. */
export function isValidCuiChecksum(cui: string): boolean {
  if (!/^\d{2,10}$/.test(cui)) return false;
  const body = cui.slice(0, -1).padStart(9, '0');
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += Number(body[i]) * Number(CONTROL_KEY[i]);
  }
  const control = ((sum * 10) % 11) % 10;
  return control === Number(cui[cui.length - 1]);
}

export type CuiValidation =
  | { ok: true; cui: string }
  | { ok: false; reason: 'empty' | 'format' | 'checksum' };

export function validateCui(raw: string): CuiValidation {
  const cui = normalizeCui(raw);
  if (!cui) return { ok: false, reason: 'empty' };
  if (!/^\d{2,10}$/.test(cui)) return { ok: false, reason: 'format' };
  if (!isValidCuiChecksum(cui)) return { ok: false, reason: 'checksum' };
  return { ok: true, cui };
}
